<template>
    <v-sheet color="bgtopology"  class="ma-4 defaultCard">
        <v-row class="ma-0" v-if="itemsLTE.length > 0">
            <v-col class="pa-0 mb-4" cols="12" align-self="center" >                
                <span  class="titlePages">{{ t('labels.statistics') }}</span>
            </v-col>
            <v-col cols="8">
                <EasyDataTable                
                show-index
                table-class-name="customize-table"
                :headers="headers"
                :items="itemsLTE"
                :rows-per-page="10"
                :hide-footer="false"
                @click-row="showDataInfo"
                >         
                </EasyDataTable>
            </v-col>
            <v-col cols="4">
                <v-row  v-if="sendData.length > 0">
                    <v-col v-for="(item, i) in sendData" :key="i" cols="6" class="pa-0">
                        <v-sheet color="transparent" class="cardStatisticsLTE py-3">
                            <v-row class="ma-0" justify='space-around'> 
                                <span>{{item.ifDescr}}</span> 
                                <v-icon icon="mdi-chart-bell-curve-cumulative" size="small" @click="showDialog(item.ifDescr)"/>
                            </v-row>
                            <table>
                                <tr>
                                    <td>MTU (Bytes)</td>
                                    <td class="pl-4">{{item.ifMtu}}</td>
                                </tr>
                                <tr>
                                    <td>Speed (Mbps)</td>
                                    <td class="pl-4">{{parseInt(item.ifSpeed)/1000000}}</td>
                                </tr>
                                <tr>
                                    <td>RX (MBytes)</td>
                                    <td class="pl-4">{{item.RXBytes}}</td>
                                </tr>
                                <tr>
                                    <td>TX (MBytes)</td>
                                    <td class="pl-4">{{item.TXBytes}}</td>
                                </tr>
                            </table>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>        
        <v-row v-else justify="center" class="ma-4">
            <Prog_circular/>
        </v-row>
    </v-sheet>
    <v-dialog v-model="dialog" width="85%" >

        <v-card class="card_dialog" color="background"> 
        <v-row class="ma-0" justify="space-between" style="align-items: self-end !important;" >
            <v-col cols="10">
                <span :class="xs ? 'textDashboard' : 'subtitleDashboard'"> {{ selectedIP }} - {{ selectedNAME }}</span>
            </v-col>
            <v-col cols="1">
                <v-btn icon="mdi-close" variant="plain" @click="closeDialog"></v-btn>
            </v-col>
        </v-row>
        <v-divider class="mt-7"></v-divider>
        <v-sheet color="transparent">
            <StatisticsComponent
            :rxbytes="finalRXBYTES"
            :txbytes="finalTXBYTES"
            />
        </v-sheet>  
    </v-card>
        
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted }  from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
import StatisticsComponent from '@/components/GestorHCGLink/dialogs/statisticsComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER, ALLHEADER }    from '@/interfaces/SmartLink/Tables';
import { ALLDATAINFO, ENLACES, LASTENLACEINFO, TABLEINFO } from '@/interfaces/GestorHCGLINK/Equips';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getItemsTablesGestor, getLast30DaysLTEGestor, getLastDatesLTEGestor, getMaxDatesLTEGestor } from '@/services/Gestor/Gestor';






const sendData:Ref<ENLACES[]> = ref([])



const finalInfoData:Ref<LASTENLACEINFO> = ref({})
const finalInfoData30Days:Ref<ALLDATAINFO> = ref({});
const selectedIP        = ref('');
const selectedNAME      = ref('');
const arrayDates:Ref<string[]>   = ref([]);
// const showDataTable     = ref(false);

async function getMaxDatesLTE() {

    const allData = await getMaxDatesLTEGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        arrayDates.value = allData.data
    }
}



async function getLastDatesLTE() {
    let params = {
        dates  : arrayDates.value
    }    
    sendData.value = [];    

    const allData = await getLastDatesLTEGestor(params)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalInfoData.value = allData.data
    }
}

async function getAllDaysLTE() {

    const allData = await getLast30DaysLTEGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalInfoData30Days.value = allData.data
    }
}

function showDataInfo(item:TABLEINFO) {
    sendData.value = [];
    sendData.value = finalInfoData.value[item.ip] ? finalInfoData.value[item.ip] : [] ;
    selectedIP.value = item.ip;
}

const finalRXBYTES:Ref<number[][]> = ref([]);
const finalTXBYTES:Ref<number[][]> = ref([]);

/**
 * Control del dialog de estadísticas
 */
const dialog = ref(false);

/**
 * Mostrar dialog con estadísticas
 * @param name Nombre del equipo
 */
function showDialog(name:string) {
    let selectedInfo = finalInfoData30Days.value[selectedIP.value][name]
    selectedNAME.value = name
    finalRXBYTES.value = selectedInfo.rxbytes;
    finalTXBYTES.value = selectedInfo.txbytes;
    dialog.value = true;
}

/**
 * Cerrar dialog
 */
function closeDialog(){
    dialog.value = false;
}



/**
 * Headers de la tabla principal
 */
const HEADERS__PRIMARY_TABLE:ALLHEADER = {
    header : [
        { text: 'IP Address',   value: "ip",            sortable: true },
        { text: 'Nombre',       value: "name",          sortable: true },
        { text: 'Tipo',         value: "tipo",          sortable: true },
        { text: 'Subitpo',      value: "subtipo",       sortable: true },
        { text: 'Mark',         value: "marca",         sortable: true },
    ]
};

/**
 * Headers de la tabla principal, inicia en array vacío
 */
const headers:Ref<HEADER[]>     = ref([]);

// Asignar los headers de la tabla principal
headers.value = HEADERS__PRIMARY_TABLE['header'];


/**
 * Lista de items de la tabla principal
 */
const itemsLTE: Ref<TABLEINFO[]> = ref([]);

/**
 * Traer datos básico de la tabla principal llamando a la api 'getIPLTE'
 */
const getItems = async() => {

    const allData = await getItemsTablesGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        itemsLTE.value = allData.data
    }
}

onMounted(async () => {
    getItems() 
    await getAllDaysLTE();
    await getMaxDatesLTE();
    await getLastDatesLTE();
})

</script>

<style scoped>
.cardStatisticsLTE{
    border-top: 2px solid rgb(var(--v-theme-colorText)) !important;
}
</style>